export default {
  adUnits: {
    max: {}
  }
}
